module.exports = __webpack_public_path__ + "static/media/ordertrack_logo.db67e5ec.png";